// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/css/semantic/semantic.css
// module id = 1085
// module chunks = 0